export const kconfig = ({
    appName: 'My App',
    appVersion: 2.0,
    apiUrl: 'https://kevinangulo.com/api/'
    //apiUrl: 'http://localhost/AppRusia2018/api/'
});


// WEBPACK FOOTER //
// ./src/app/globals.ts